<template>
  <section>
    <!--工具条-->

    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
      <el-button type="primary" size="small" @click="removeData">删除</el-button>
    </el-col>

    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>
    <el-table :data="tableData"
              border
              @selection-change="selsChange"
              v-loading="listLoading">
                <el-table-column
        label="编号"
        prop="fid"
        align="center">
      </el-table-column>
      <el-table-column
        label="分类名"
        prop="fname"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="labels"
        align="center">
        <template scope="scope">
          <el-button size="small" type="primary"  @click="editHandler(scope.row)">修改</el-button>
          <el-button size="small" type="primary"  @click="deleteHandler(scope.row.fid)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>
    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="分类名称" prop="fname">
          <el-input v-model="addForm.fname" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="分类名称" prop="fname">
          <el-input v-model="editForm.fname" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          fname: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {}
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/firstmenu/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.addForm);
              //异步请求
              this.$axios.post(config.api_url + '/firstmenu',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },

      //操作删除
      deleteHandler(id){
        if(id !=0){
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/firstmenu/delete/' + id
            ).then(response => {
              if(response.data.state) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              this.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }

      },

      //勾选删除数据
      removeData() {
        if(this.selectRow.length > 0) {
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if(this.selectRow.length == 1) {
              this.$axios.delete(config.api_url + '/firstmenu/delete/' + this.selectRow[0].fid
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '删除异常，请联系管理员',
                  type: 'error'
                });
              });
            } else {
              let ids = '',
                para = {};
              for(let row of this.selectRow) {
                ids += row.fid + ','
              }
              ids = ids.substring(0,ids.length - 1);
              this.$axios.delete(config.api_url + '/firstmenu/batch/delete/' + ids
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '删除异常，请联系管理员',
                  type: 'error'
                });
              });
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          this.$message({
            message: '请选择一条数据操作',
            type: 'warning'
          });
        }
      },
      //获取选中的数据
      selsChange(row) {
        this.selectRow = row
      },

      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              //异步请求
              this.$axios.put(config.api_url + '/firstmenu',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// firstmenu.vue?52632918